import { DataFormatterType } from '../DataFormatterType';
import { DataFormatterOptions } from '../DataFormatterType';
import { DataTools } from '../../utils/DataTools';
import { Localizer } from '../../localize/localizer';

/**
 * Data formatter for general text types
 * @ignore
 */
export class DataFormatText extends DataFormatterType
{
    getName() : string
    {
        return "text";
    }

    // Text alignment default
    getAlign() : string
    {
        return "left";
    }

    /* Return option text to the right of the display value */
    getUnitText(options ?: DataFormatterOptions) : string
    {
		if (options && options.displayunit && options.displayunit.length > 0)
			return options.displayunit;
        return "";
    }

    /* Default options for the number formatter */
    initializeOptions() : DataFormatterOptions
    {
        return {
        }
    }

    /*
    Format data as a number.
    Options can have format='<numeral js template>'
    */
    format(data: any, options?: DataFormatterOptions, refObj?: any): string
    {
        const myOptions : DataFormatterOptions = this.getOptions(options);

        if (!data)
        {
            return "";
        }

        // TODO: Detect Date text based on regex?

        if (typeof data === "string")
            return data;

        return data.toString();
    }

    /*
    Format the data for export.  As this is a basic type, we want CSV files
    to have the raw number value.
    */
    formatExport(data: any, options?: DataFormatterOptions, refObj?: any): any
    {
        const stringValue = this.format(data, options, refObj);

        // TODO: Do we need to remove any special characters or anything else?
        return stringValue;
    }

    //
    // funtion to unformat the currently formatted data
    //
    // @param [Object] data data to be unformatted
    // @param [String] path path where the value is being edited
    // @return [Object] data unformatted data
    //
    unformat(data: any, refObject?: any) : any
    {
        if (data === undefined) return "";
        if (data === null) return "";

        if (typeof(data) === "string")
            return data;

        if (data && data.toString)
        {
            return data.toString();
        }

        console.warn("DataFormText unform unknown input:", data, typeof(data));
        return "";
    }

};
